import React, { useEffect, useState } from 'react'
import { Grid, Paper, Box } from '@mui/material'
import _ from 'lodash'

//import '../../../styles/print.css'
import KeyAreaSections from "./KeyAreaSections";


const KeyAreaCards = (props) => {
    const [PrintView, setPrintView] = useState(false)
    useEffect(()=>{setPrintView(props.PrintView)},[props.PrintView])

    const [sections, setSections] = React.useState(props.cards)

    const sectionsToShow = _.filter(sections.KeyAreaArray, {Visible:"1"})
    
    if (props.cards && sectionsToShow) {
        return (
            <Box>
                <Grid container spacing={3} sx={{marginLeft: '-12px' }}> 

                    {
                        sectionsToShow && sectionsToShow.map((keyAreaSection, index) => {
                            return (
                                <Grid className="pagebreak"  lg={12} md={12} sm={12} xs={12} display="flex" justifyContent="center" alignItems="center" sx={{ padding: '10px' }}>
                                 <div style={{ breakBefore: 'page' }}></div>
                                    <div /> 
                                        <KeyAreaSections
                                            key={index}
                                            KeyAreaArray={sectionsToShow[index]}
                                            PrintView={PrintView}
                                        />
                                    
                                </Grid>
                            )
                        })
                    }

                </Grid>
            </Box>

        )
    } else {
        return (<Box></Box>)
    }
}


export default KeyAreaCards;